import Header from "@/components/Header";
import Footer from "@/components/Footer";

const AvisoLegal = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24 pb-16">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
            Aviso Legal
          </h1>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-8">
            <p className="text-sm text-muted-foreground">
              Última actualización: Enero 2026
            </p>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                1. Datos identificativos del titular
              </h2>
              <p>
                En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, 
                de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), 
                se informa al usuario de los siguientes datos:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Denominación social:</strong> HABITUSPAY ESPAÑA SL</li>
                <li><strong>CIF:</strong> B24795155</li>
                <li><strong>Domicilio social:</strong> Calle La Palma, 1 - Ptl 6, Piso 1 D, 28850 Torrejón de Ardoz, Madrid, España</li>
                <li><strong>Datos registrales:</strong> Inscrita en el Registro Mercantil de Madrid, Tomo 47302, Hoja M-853516</li>
                <li><strong>Correo electrónico:</strong> soporte@habituspay.com</li>
                <li><strong>Sitio web:</strong> https://habituspay.com</li>
                <li><strong>Actividad:</strong> Desarrollo y comercialización de software de gestión financiera (SaaS)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                2. Objeto y ámbito de aplicación
              </h2>
              <p>
                El presente Aviso Legal regula el acceso y uso del sitio web habituspay.com 
                (en adelante, "el Sitio Web"), así como las responsabilidades derivadas de su utilización.
              </p>
              <p className="mt-4">
                El acceso al Sitio Web es gratuito y no requiere suscripción o registro previo. 
                No obstante, el acceso a determinados servicios y contenidos puede estar condicionado 
                a la cumplimentación del correspondiente formulario de registro.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                3. Naturaleza del servicio
              </h2>
              <p>
                <strong>HabitusPay es una plataforma de software de gestión financiera (SaaS).</strong>
              </p>
              <p className="mt-4">
                Es importante destacar que:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>HabitusPay <strong>NO es una entidad financiera</strong> ni un banco.</li>
                <li>HabitusPay <strong>NO ofrece cuentas bancarias</strong> ni servicios de custodia de fondos.</li>
                <li>HabitusPay <strong>NO emite tarjetas</strong> directamente. Las tarjetas empresariales 
                    son emitidas por proveedores externos regulados, como Wallester AS 
                    (entidad de dinero electrónico autorizada por el Banco de Estonia).</li>
                <li>HabitusPay actúa exclusivamente como plataforma tecnológica para la gestión 
                    y control de gastos empresariales.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                4. Propiedad intelectual e industrial
              </h2>
              <p>
                Todos los contenidos del Sitio Web, incluyendo textos, fotografías, gráficos, 
                imágenes, iconos, tecnología, software, enlaces y demás contenidos audiovisuales 
                o sonoros, así como su diseño gráfico y códigos fuente, son propiedad intelectual 
                de HABITUSPAY ESPAÑA SL o de terceros, sin que puedan entenderse cedidos al usuario 
                ninguno de los derechos de explotación reconocidos por la normativa vigente.
              </p>
              <p className="mt-4">
                Las marcas, nombres comerciales o signos distintivos son titularidad de 
                HABITUSPAY ESPAÑA SL o de terceros, sin que pueda entenderse que el acceso 
                al Sitio Web atribuye ningún derecho sobre los mismos.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                5. Condiciones de uso
              </h2>
              <p>
                El usuario se compromete a hacer un uso adecuado de los contenidos y servicios 
                ofrecidos a través del Sitio Web y a no emplearlos para:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Realizar actividades ilícitas o contrarias a la buena fe y al orden público.</li>
                <li>Difundir contenidos o propaganda de carácter ilegal, violento, pornográfico, 
                    racista, xenófobo, ofensivo, de apología del terrorismo o atentatorio contra 
                    los derechos humanos.</li>
                <li>Provocar daños en los sistemas físicos y lógicos del Sitio Web, de sus 
                    proveedores o de terceros.</li>
                <li>Intentar acceder y, en su caso, utilizar las cuentas de otros usuarios.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                6. Exclusión de responsabilidad
              </h2>
              <p>
                HABITUSPAY ESPAÑA SL no se hace responsable de:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Los daños y perjuicios de toda naturaleza que pudieran derivarse del uso 
                    de los servicios y contenidos del Sitio Web por parte de los usuarios.</li>
                <li>La falta de disponibilidad, mantenimiento y efectivo funcionamiento del 
                    Sitio Web y/o de sus servicios.</li>
                <li>Los daños producidos por virus informáticos o cualquier otro elemento 
                    que pudiera producir alteraciones en el sistema informático del usuario.</li>
                <li>Los contenidos de las páginas web de terceros a las que se pueda acceder 
                    mediante enlaces desde el Sitio Web.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                7. Legislación aplicable y jurisdicción
              </h2>
              <p>
                Para la resolución de todas las controversias o cuestiones relacionadas con el 
                presente Sitio Web o de las actividades en él desarrolladas, será de aplicación 
                la legislación española, a la que se someten expresamente las partes, siendo 
                competentes para la resolución de todos los conflictos derivados o relacionados 
                con su uso los Juzgados y Tribunales del domicilio del usuario si este tiene 
                la condición de consumidor, o los de la sede de HABITUSPAY ESPAÑA SL en caso contrario.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                8. Contacto
              </h2>
              <p>
                Para cualquier consulta relacionada con este Aviso Legal, puede contactar con 
                nosotros a través del correo electrónico: <a href="mailto:soporte@habituspay.com" 
                className="text-accent hover:underline">soporte@habituspay.com</a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AvisoLegal;
